import { closeModalHelper, openModalHelper } from '../../js/helpers/modals'

export default () => {
  const addNewProperty = document.querySelector('.js-add-new-property')
  const propertyEditFormWrap = document.querySelector('.form-property-wrap')
  const propertyEditForm = document.querySelector('.form-property')

  const propertyFormItem = document.querySelector('.js-property-form')
  const editPropertyArray = document.querySelectorAll('.js-edit-property')
  const optionArr = document.querySelectorAll(
    '.form-property .js-property-type-select option'
  )
  const propertyFormTitle = document.querySelector('.form-property__title')

  function openPropertyModal() {
    propertyEditForm.classList.add('opened')
    propertyEditFormWrap.classList.add('opened')
    openModalHelper()
  }

  if (addNewProperty) {
    addNewProperty.addEventListener('click', () => {
      propertyFormTitle.textContent = 'Add New Property'
      propertyEditForm.querySelector('[data-property-price-from]').value = 50000

      propertyEditForm.querySelector(
        '[data-property-price-to]'
      ).value = 15000000
      openPropertyModal()
    })
  }

  let clearModalInputs

  editPropertyArray.forEach(btn => {
    btn.addEventListener('click', event => {
      const prefilledValue = {}
      const parentElement = event.target.parentNode.parentNode.parentNode

      propertyFormTitle.textContent = 'Edit your Property'

      prefilledValue['data-property-type'] = parentElement.querySelector('[data-property-type]').dataset.propertyType
      prefilledValue['data-property-id'] = parentElement.dataset.propertyId
      prefilledValue['data-property-date'] = parentElement.querySelector('[data-property-date]').dataset.propertyDate
      prefilledValue['data-property-location'] = parentElement.querySelector('[data-property-location]').dataset.propertyLocation
      prefilledValue['data-property-state-code'] = parentElement.dataset.propertyState
      prefilledValue['data-property-bedrooms'] = parentElement.querySelector('[data-property-bedrooms]').dataset.propertyBedrooms
      prefilledValue['data-property-bathrooms'] = parentElement.querySelector('[data-property-bathrooms]').dataset.propertyBathrooms
      prefilledValue['data-property-car-space'] = parentElement.querySelector('[data-property-car-space]').dataset.propertyCarSpace
      prefilledValue['data-property-size'] = parentElement.querySelector('[data-property-size]').dataset.propertySize
      prefilledValue['data-property-price-from'] = parentElement.querySelector('[data-property-price-from]').dataset.propertyPriceFrom
      prefilledValue['data-property-price-to'] = parentElement.querySelector('[data-property-price-to]').dataset.propertyPriceTo

      Object.keys(prefilledValue).map(key => {
        let currentInput = propertyEditFormWrap.querySelector(`[${key}]`)

        if (currentInput) {
          if (currentInput.className.includes('js-property-type-select')) {
            optionArr.forEach(option => {
              if (prefilledValue[key] === '') {
                currentInput.parentElement.querySelector('.is-selected.has-focus').classList.remove('is-selected', 'has-focus')
                currentInput.parentElement.querySelector(`.custom-select-option:first-child`).classList.add('is-selected', 'has-focus')
              } else if (option.value == prefilledValue[key]) {
                currentInput.parentElement.querySelector('.custom-select-opener span').textContent = option.textContent

                if (currentInput.parentElement.querySelector('.is-selected.has-focus')) {
                  currentInput.parentElement
                    .querySelector('.is-selected.has-focus')
                    .classList.remove('is-selected', 'has-focus')
                }

                currentInput.parentElement
                  .querySelector(`.custom-select-option[data-value="${prefilledValue[key]}"]`)
                  .classList.add('is-selected', 'has-focus')
              }
            })
          }

          if (
            currentInput.className.includes('js-property-type-select') &&
            prefilledValue[key] === ''
          ) {
            currentInput.value = $('.js-property-type-select option:first-child').val()
          } else {
            currentInput.value = prefilledValue[key]
          }

          $(`.js-property-state-code option[value="${prefilledValue['data-property-state-code']}"]`).attr('selected', 'selected')
          $(`.custom-select-option[data-value="${prefilledValue['data-property-state-code']}"]`).trigger('click')
        }
      })

      clearModalInputs = () => {
        Object.keys(prefilledValue).map((key) => {
          let currentInput = propertyEditFormWrap.querySelector(`[${key}]`)
          if (
            currentInput &&
            currentInput.classList.contains('js-property-type-select')
          ) {
            const activeOption = currentInput.parentNode.querySelector(
              '.is-selected.has-focus'
            )
            if (activeOption) {
              activeOption.classList.remove('is-selected', 'has-focus')
            }
          }
          if (currentInput) {
            currentInput.value = ''
          }
        })
      }

      openPropertyModal()
    })
  })

  let $ = jQuery

  const mainModal = document.querySelector('.form-property')
  const modalWrap = document.querySelector('.form-property-wrap')

  const thankYouModal = document.querySelector('.form-property-thank')
  const errorModal = document.querySelector('.form-property-error')

  const modalClose = Array.from(
    document.querySelectorAll('.form-property__close')
  )
  const modalHandlers = Array.from(
    document.querySelectorAll('.form-property-handler')
  )

  const pageproperty = Array.from(
    document.querySelectorAll('.form-page-property')
  )

  const loader = document.querySelector('.form-property-loader')

  const toggleElement = (el, text = '', isError = false) => {
    el.classList.toggle('opened')

    if (isError) {
      if (text === '') {
        text =
          "Sorry, there was an error while sending your data. <br>We're\n" +
          '\t\t\talready\n' +
          '\t\t\tfixing it!'
      }
      $(el).find('div:last').text(text)
    }
  }

  modalHandlers.forEach((modalHandler) => {
    modalHandler.addEventListener('click', (event) => {
      event.preventDefault()
      modalWrap.classList.add('opened')
      toggleElement(mainModal)
      openStep(1)
      document.body.classList.add('js-no-scroll')
      openModalHelper()
    })
  })

  modalClose.forEach(function (modalCloseEl) {
    modalCloseEl.addEventListener('click', () => {
      console.log('close')
      modalWrap.classList.remove('opened')
      mainModal.classList.remove('opened')
      errorModal.classList.remove('opened')
      thankYouModal.classList.remove('opened')
      if (clearModalInputs) clearModalInputs()
      document.body.classList.remove('js-no-scroll')
      closeModalHelper()
    })
  })

  // closing modal on clicking outside the modal
  modalWrap.addEventListener('click', function (event) {
    if (
      !event.target.classList.contains('.form-property-popup') &&
      !event.target.closest('.form-property-popup')
    ) {
      modalWrap.classList.remove('opened')
      mainModal.classList.remove('opened')
      errorModal.classList.remove('opened')
      thankYouModal.classList.remove('opened')

      let currentInput = propertyEditFormWrap.querySelector(`select`)
      if (
        currentInput &&
        currentInput.classList.contains('js-property-type-select')
      ) {
        const activeOption = currentInput.parentNode.querySelector(
          '.is-selected.has-focus'
        )
        currentInput.value = ''
        if (activeOption) {
          activeOption.classList.remove('is-selected', 'has-focus')
          currentInput.parentElement
            .querySelector(`.custom-select-option:first-child`)
            .classList.add('is-selected', 'has-focus')
        }

        currentInput.parentElement.querySelector(
          '.custom-select-opener span'
        ).textContent = optionArr[0].textContent
      }

      if (clearModalInputs) clearModalInputs()
      closeModalHelper()
      document.body.classList.remove('js-no-scroll')
    }
  })

  // validation
  function checkForErrors(form) {
    const inputReserve = form.querySelector('input[name="reserveAmount"]')
    const inputCheckbox = form.querySelector('input[name="valuationFeedback"]')
    if (!inputReserve || !inputCheckbox) return

    const formError = form.querySelector('.form-error')
    let errors
    if (inputReserve.value == '' && !inputCheckbox.checked) {
      errors = true
      formError.style.display = 'block'
    } else if (inputReserve.value || inputCheckbox.checked) {
      errors = false
      formError.style.display = 'none'
    }
    return errors
  }

  const formatNumber = document.querySelectorAll('.format-number')
  if (formatNumber.length) {
    Array.from(formatNumber).forEach(function (input) {
      input.addEventListener('input', function () {
        input.value = input.value.replace(/[^0-9\.+]+/g, '')
      })
    })
  }

  propertyFormItem.addEventListener('submit', event => {
    event.preventDefault()

    const propertyFormItemData = $(propertyFormItem).serializeArray()
    let action = ''

    if (propertyFormItem.querySelector('input[data-property-id]').value === '') {
      action = 'createProperty'
    } else {
      action = 'updateProperty'
    }

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      data: {
        action,
        data: propertyFormItemData,
      },
      beforeSend: () => {
        mainModal.classList.remove('opened')
        toggleElement(loader)
      },
      success: response => {
        toggleElement(loader)
        if (response.data.status === 'success') {
          toggleElement(thankYouModal)
          window.location = window.location.pathname + '?isProfileTab=true'
        } else {
          toggleElement(errorModal, response.data.message, true)
          console.log(response)
        }
      },
      error: error => {
        toggleElement(loader)
        toggleElement(errorModal)
        console.log(error)
      },
    })
  })
}
